<!--
 * @message: 数字输入框（带加减按钮）
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-09-08 18:27:19
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_numberInputTextFiled.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-07 16:07:54
-->
<template>
  <div class="d-flex justify-start flex-column numberInput">
    <v-sheet class="text--secondary d-inline-block text-truncate">
      <span :class="labelClass" v-if="showLabel">{{ label }}</span>
    </v-sheet>
    <v-text-field
      class="text-center"
      v-model="curValue"
      :filled="filled"
      :single-line="singleLine"
      :hint="hint"
      :height="height"
      :maxlength="maxlength"
      @input="changeNumber"
      :type="filled ? type : 'text'"
      :prepend-inner-icon="filled ? 'mdi-minus' : ''"
      :append-icon="filled ? 'mdi-plus' : ''"
      @click:prepend-inner="filled ? minus() : null"
      @click:append="filled ? plus() : null"
      @focus="
        focus = true;
        canFocus = true;
      "
      @blur="
        focus = false;
        changeNumber();
      "
      :rules="canFocus ? rules : []"
      :dense="dense"
      :error="isError"
      :error-messages="errorMsg"
      :disabled="disabled"
      :readonly="readonly"
    ></v-text-field>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "mrc_normal_input",
  model: {
    prop: "value",
    event: "input",
  },
  computed: {
    ...mapGetters(["pageTriger"]),
    curValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        return val;
      },
    },
    isRequire() {
      return this.rules.length ? true : false;
    },
    labelClass() {
      let cla = "";
      if (this.isRequire && !this.isNotRequire) {
        cla += " mrc_text_require";
      }
      if (this.focus) {
        cla += " primary--text";
      }
      if (this.isError) {
        cla += " red--text";
      }
      return cla;
    },
    isError() {
      // if (this.pageTriger && this.rules) {
      //   return this.isObjectNull(this.valueArr);
      // }

      if (!this.canFocus) {
        return false;
      }
      if (this.rules == null || this.rules.length == 0) {
        return false;
      }
      return this.isObjectNull(this.curValue);
    },
    errorMsg() {
      if (this.rules == null || this.rules.length == 0) {
        return "";
      }
      if (this.isObjectNull(this.curValue)) {
        return (
          this.$t("verify_essweb_form_textField_dataCommonLabel") +
          this.$t("verify_essweb_form_textField_dataIsIllegalLabel")
        );
      } else {
        return null;
      }
    },
  },
  props: {
    //规则
    rules: {
      default: function () {
        return [];
      },
      type: Array,
    },
    isNotRequire: { default: false, type: Boolean },
    value: { default: 1, type: [Number, String] },
    label: { default: "", type: String },
    maxlength: { default: "", type: [String, Number, Array, Object] },
    height: { default: "", type: [String, Number] },
    singleLine: { default: true, type: Boolean },
    showLabel: { default: true, type: Boolean },
    hint: { default: "", type: String },
    type: { default: "number", type: [String] },
    filled: { default: true, type: Boolean },
    readonly: { default: false, type: Boolean },
    disabled: { default: false, type: Boolean },
    dense: { default: true, type: Boolean },
    max: { default: "", type: [Number, String] },
    min: { default: "", type: [Number, String] },
  },

  watch: {
    pageTriger(val) {
      if (val) this.canFocus = true;
    },
    value(val) {
      this.curValue = val;
    },
    curValue(val) {
      this.$emit("input", Number(val));
    },
  },
  data() {
    return { focus: false, canFocus: false };
  },
  mounted() {
    this.canFocus = false;
  },
  methods: {
    changeNumber() {
      let str = "" + this.curValue;
      if (str.indexOf(".") != -1) {
        let arr = str.split("");
        arr.splice(arr.length - 1);
        let str2 = arr.join("");
        this.curValue = +str2;
      }
    },
    plus: function (val) {
      if (this.max !== "") {
        if (Number(Number(this.curValue) + 1) > Number(this.max)) {
          this.curValue = Number(this.max);
        } else {
          this.curValue = Number(this.curValue) + 1;
        }
      } else {
        this.curValue = Number(this.curValue) + 1;
      }
    },
    minus: function (val) {
      if (this.min !== "") {
        if (Number(Number(this.curValue) - 1) < Number(this.min)) {
          this.curValue = Number(this.min);
        } else {
          this.curValue = Number(this.curValue) - 1;
        }
      } else {
        this.curValue = Number(this.curValue) - 1;
      }
    },
    isObjectNull: function (obj) {
      const that = this;
      if (obj === 0) {
        return false;
      }
      if (obj === "") {
        return true;
      }
      return false;
    },
  },
};
</script>
<style >
.numberInput .v-text-field input[type="number"] {
  text-align: center !important;
  line-height: inherit !important;
}
/* .numberInput .v-input--is-readonly input[type="text"] {
  text-align: center !important;
  line-height: inherit !important;
} */
</style>